 
import AppModal from "components/Modal";
import React, { useEffect,  useState } from "react";
import ReactDOM from "react-dom"; 
import { useForm } from "react-hook-form";
import { useAuth } from '../../../helpers/authContext';
import {
  Button, Card, CardBody, FormGroup, Form, Alert, Row, Col,
  Input, Label
} from "reactstrap"; 
import { postCreateWithWif } from "helpers/steem";
// import { useNavigate } from 'react-router-dom';
import { postCreateKeychain } from "helpers/keychain";
import { isLoggedWithKeychain } from "services/dsteem-service"; 
import FullEditor from "components/FullEditor"; 
import { get_ipfs_usage } from "services/db-service";
import { getContent } from "services/posts-service";
import renderer, { replaceIPFSVideoLinks } from 'helpers/contentRenderer';
import { renderHTMLSafe } from "services/posts-service";

type FormData = { 
  title: string, 
  description: string, 
  tags: any
};

type Props = {
    post:any,
    title:any,
    description:any,
    tags:any,
    isShowing: boolean,
    isComment: boolean,
    hide: any,
    onSuccess: Function;
}

function validate(data: FormData,isComment, setErrorMessage ) {
  let validated = true; 
  if (!isComment && (!data.tags || data.tags.length === 0)) {
    setErrorMessage("Add up to 8 tags separated with spaces.");
    validated = false;
  }
  if (!data.description) {
    setErrorMessage("Please add a description for your post.");
    validated = false;
  }
  if (!isComment && !data.title) {
    setErrorMessage("Please add a title.");
    validated = false;
  }
  return validated;
}

export const ContentEditPostModal = ({ title, description, tags,post, isShowing,isComment,onSuccess, hide }: Props) => { 
    const { user, autologin, app_settings } = useAuth(); 
    let edit = post;  
    let metadata = null;
    try {
        metadata = JSON.parse(edit.json_metadata);
    } catch (error) {
        console.log(error);
        
    }
    const [loading, setLoading] = useState(false);
    const { register, handleSubmit, setValue, watch } = useForm<FormData>({ 
        defaultValues: {
            title: title || '', 
            description: description || '',
            tags: Array.isArray(tags) ? tags.join(' ') : tags || 'steemvideo' 
        },
    });

    
    // const navigate = useNavigate();
    const [step, setStep] = useState(1);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [orientation, setOrientation] = useState<"clip" | "video">(metadata?.display_type || "video");
    const [ipfsAccount, setIpfsAccount] = useState<any>({});  
    const keychainLogin = isLoggedWithKeychain(autologin); 
    useEffect(() => {
        if (isShowing) { 
            setValue("title", title || ""); 
            setValue("tags", Array.isArray(tags) ? tags.join(' ') : tags || "");
            setValue("description", description || "");
        }
    }, [isShowing]);
    useEffect(() => {
        (async () => {
            const ipfs = await get_ipfs_usage(user); 
            setIpfsAccount(ipfs || []);
        })()
    }, []); 

    const onSubmit = async (data: FormData) => {
        data.tags = data.tags.toLowerCase().replace(/#/g, "").split(' '); 
        setLoading(true);
        const success = validate(data,isComment, setErrorMessage); 
        let disabled = false; 
        let cover = "";
        const imageMatches = [...post.body.matchAll(/(?:!\[.*?\]\()?(https?:\/\/[^\s)"']+\.(?:png|jpe?g|webp|gif))(?:\))?/gi)];
        let images = imageMatches.map(match => match[1]) 
            .map(url =>
              url
                .replace(/^[('"`]+/, '') 
                .replace(/[)'"`]+$/, '')
            );

        if (images && images[0]) {
            cover = images[0];
        }
        let category = (edit.category)?edit.category:data.tags[0].toLowerCase();
        if (edit.depth > 0) {
            category = edit.parent_permlink
        }
        const postData = {
            ...edit,
            cover:cover,
            title:data.title || "",
            body:data.description,
            display_type: orientation,
            tags: data.tags || "", 
            category: category
        };
        if (success && !disabled) { 
            const publish = keychainLogin
                ? () => postCreateKeychain(postData, user, false)
                : () => postCreateWithWif(postData, autologin, false);

            publish()
                .then(async (result: any) => { 
                    if (result.success) {
                        let newEntry = await getContent(postData.author, postData.permlink);
                        onSuccess(newEntry); 
                    } else {
                        console.log(result.result.message); 
                        setErrorMessage(result.result.message);
                    }
                    setLoading(false);
                })
                .catch(() => setErrorMessage("Something went wrong."));
        } 
    }; 
    const handleNext = (e) => {
        e.preventDefault();
        setStep(2);
    }
    const handleBack = (e) => {
        e.preventDefault();
        setStep(1);
    }

    const renderStep1 = (
        <>
            <Row >  
                {!isComment && (
                    <Col md="12">
                        <FormGroup>
                            <input className="form-control fancy-input" name="title" placeholder="Title"
                            defaultValue={title || ""}
                            {...register("title")} />
                        </FormGroup>
                    </Col> 
                )}
                <Col md="12">
                    <FullEditor 
                        register={register}
                        watch={watch}
                        setValue={setValue}
                        IpfsAccount={ipfsAccount}
                        setOrientation={setOrientation}
                    />
                </Col>
                {!isComment && (
                    <>
                    <Col md="12" className="mb-3 d-flex align-items-center">
                        <div className="d-flex gap-3">
                            <div
                            className={`orientation-option d-flex align-items-center px-3 py-2 rounded cursor-pointer ${
                                orientation === "clip" ? "checked" : "border"
                            }`}
                            onClick={() => setOrientation("clip")}
                            >
                            <img src={`${(app_settings.app_mode && app_settings.app_mode == "default")?"/assets/img/v-black.png":"/assets/img/v-white.png"}`}  className='clips-icon' />
                            <Input
                                type="checkbox"
                                checked={orientation === "clip"}
                                onChange={() => setOrientation("video")}
                                hidden
                            />
                            </div>
                            <div
                            className={`orientation-option d-flex align-items-center px-3 py-2 rounded cursor-pointer ${
                                orientation === "video" ? "checked" : "border"
                            }`}
                            onClick={() => setOrientation("video")}
                            >
                            <img src={`${(app_settings.app_mode && app_settings.app_mode == "default")?"/assets/img/h-black.png":"/assets/img/h-white.png"}`}  className='clips-icon' />
                            <Input
                                type="checkbox"
                                checked={orientation === "video"}
                                onChange={() => setOrientation("video")}
                                hidden
                            />
                            </div>
                        </div>
                    </Col>
                    <Col md="12">
                        <FormGroup>
                            <input className="form-control fancy-input" name="tags" placeholder="Tags" defaultValue="#steemvideo" {...register("tags")} />
                        </FormGroup> 
                    </Col>
                    </>
                )}
                
            </Row>
        </>
    );

    let body = null;
    try {
        let description = watch("description")?.trim();
        if (description) {
            body = (
                <div className="body-content">
                    {renderHTMLSafe(replaceIPFSVideoLinks(renderer.render(description)))}
                </div>
            );
        } else {
            body = (
                <div className="text-muted text-center py-5">
                    <i className="fas fa-eye-slash fa-2x mb-2" />
                    <p>No preview available.</p>
                </div>
            );
        }
    } catch (error) {
        body = (
            <div className="text-danger text-center py-5">
                <p>Failed to render preview.</p>
            </div>
        );
    }
    const renderStep2 = (
        <div className="preview-container p-3">
            <h3 className="mb-3">{watch("title")}</h3>
            <hr />
            {body}
            <div className="mt-4">
                <Label className="text-muted">Tags:</Label>
                <div className="d-flex flex-wrap gap-2">
                    {watch("tags")?.split(' ').map((tag, index) => (
                        <span key={index} className="badge badge-pill badge-neutral p-2 px-3">{tag}</span>
                    ))}
                </div>
            </div>
        </div>
    ); 
  
    const renderForm = (
        <div className="modal-body post-editor-body mt-0 p-0">
        <Card className="shadow border-0">
            <CardBody className="px-lg-3 pt-0 pb-0 body-gray">
            
            <div className="relative w-100 flex-shrink-0">
                <div className="post-way empty w-100"> 
                </div>
                <div className="post-way filled" style={{position:"absolute",top:0,width:((step/2)*100)+"%"}}> 
                </div>
                <div className={`step-name text-muted ${step > 1?"active":""}`} onClick={() => setStep(1)} style={{width:"50%"}}>
                    Editor
                </div>
                <div className={`step-name text-muted text-right ${step > 1?"active":""}`} onClick={() => setStep(2)} style={{width:"50%"}}>
                    Preview
                </div>
            </div>

            {errorMessage && <Alert color="danger">{errorMessage}</Alert>} 
            <Form className="post-editor-wrapper"> 
                <div className="post-editor-scroll-area">
                    {step === 1 && renderStep1}
                    {step === 2 && renderStep2}
                </div>
                <div className="post-editor-buttons"> 
                    {step === 1 ? (
                        <Button color="secondary" onClick={handleNext}>Next <i className="fas fa-chevron-right" /></Button>
                    ) : (
                        <>
                            <Button color="secondary" onClick={handleBack}><i className="fas fa-chevron-left" /> Back</Button>
                            <Button color="default" onClick={handleSubmit(onSubmit)} disabled={loading}>
                                {loading && <span className="spinner" />}
                                {!loading && (keychainLogin ? <>Update with <img className="icon icon-sm ml-1" src="/assets/img/keychain.svg" /></> : "Update")}
                            </Button> 
                        </>
                    )}
                </div>
            </Form>
            </CardBody>
        </Card>
        </div>
    );

    return isShowing
        ? ReactDOM.createPortal(
            <AppModal isShowing={isShowing} hide={hide} size="lg" header="Video Studio">
            {renderForm}
            </AppModal>, document.body
        )
        : null;
};

export default ContentEditPostModal;
